import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/**
 * Подписи типов событий матча. Ключ — тип в нижнем регистре: в протоколе (`GameEventType`) часть
 * значений заглавные, в моментах игрока тип приходит из трансляции (`yellowcard`, `penalty_missed`),
 * поэтому словарь шире enum-а.
 */
const GAME_EVENT_TYPE_LABELS: Record<string, MessageDescriptor> = {
  goal: msg`Гол`,
  pass_and_goal: msg`Пас и гол`,
  foul: msg`Фол`,
  corner: msg`Угловой`,
  penalty: msg`Пенальти`,
  timeout: msg`Перерыв`,
  replacement: msg`Замена`,
  yellowcard: msg`Желтая карточка`,
  yellow_card: msg`Желтая карточка`,
  redcard: msg`Красная карточка`,
  red_card: msg`Красная карточка`,
  owngoal: msg`Автогол`,
  after_match_penalty_goal: msg`Гол`,
  after_match_penalty_missed: msg`Промах`,
  penalty_missed: msg`Промах пенальти`,
};

/** Неизвестный тип (`save`, `default`) — `undefined`: подпись по месту берёт исходную строку. */
export function getGameEventTypeLabel(type?: string | null): MessageDescriptor | undefined {
  return type ? GAME_EVENT_TYPE_LABELS[type.toLowerCase()] : undefined;
}
